import getIconNameFromCode from '@/components/Inclusion/utils/getIconNameFromCode';
import { InclusionItem } from '@/v2/components/ui/PackageInclusions/Inclusion';
import { Inclusion } from '@/v2/services/sanity/types/api/response';
import { HotelInclusion } from '@/v2/services/types/api/parsedResponse';

export const convertLeadInOfferInclusion = (
  inclusion: Inclusion,
): InclusionItem => ({
  title: inclusion.name,
  subtitle: inclusion.subtitle,
  icon: getIconNameFromCode(inclusion.code),
});

export const convertedHotelOfferInclusion = (
  inclusion: HotelInclusion,
): InclusionItem => ({
  title: inclusion.name || inclusion.description,
  icon: getIconNameFromCode(inclusion.code),
});
